document.addEventListener('DOMContentLoaded', function () {
  try {
    // Only run on product pages
    if (!window.location.pathname.includes('/products/')) return;

    // 1. Read blocked variant IDs from Liquid metafield
    var raw = window.PK_BLOCKED_VARIANTS;
    if (!raw) return;

    var blockedVariantIds = [];

    if (Array.isArray(raw)) {
      blockedVariantIds = raw.map(String);
    } else if (typeof raw === 'string') {
      blockedVariantIds = raw
        .split(',')
        .map(function (s) { return s.trim(); })
        .filter(Boolean)
        .map(String);
    }

    if (!blockedVariantIds.length) return;

    var url = new URL(window.location.href);
    var currentVariantId = url.searchParams.get('variant');

    // Only act if the LANDING variant is blocked
    if (!currentVariantId || blockedVariantIds.indexOf(String(currentVariantId)) === -1) {
      return;
    }

    // 2. Find variant selector
    var variantSelect =
      document.querySelector('form[action^="/cart/add"] select[name="id"]') ||
      document.querySelector('select[name="id"]') ||
      document.querySelector('[data-product-form] [name="id"]');

    // If no selector exists (rare), just remove variant param → Shopify chooses default
    if (!variantSelect) {
      url.searchParams.delete('variant');
      window.location.replace(url.toString());
      return;
    }

    // 3. Pick first allowed variant
    var fallbackOption = Array.from(variantSelect.options).find(function (opt) {
      if (opt.disabled) return false;
      return blockedVariantIds.indexOf(String(opt.value)) === -1;
    });

    if (!fallbackOption) return;

    // 4. Switch variant & update URL
    variantSelect.value = fallbackOption.value;
    url.searchParams.set('variant', fallbackOption.value);
    window.history.replaceState({}, '', url.toString());

    // Trigger change so theme updates images/price/etc.
    variantSelect.dispatchEvent(new Event('change', { bubbles: true }));

  } catch (e) {
    console.warn && console.warn('block-variant-landing error', e);
  }
});
